import { HttpResponse } from '@angular/common/http';

export class NgxExcelHttpResponse {

  protected originalResponse: HttpResponse<any>;
  protected meta: { [name: string]: any };
  protected model: any;
  protected collections: { [name: string]: Array<any> } = {};

  constructor(
    protected httpResponse: HttpResponse<any>
  ) {
    this.originalResponse = httpResponse;
  }

  protected getResponseBody(): {
    code?: number, message?: string, meta?: { [name: string]: any }, data?: any, _embedded?: { [name: string]: any[] }
  } {
    return this.originalResponse ? this.originalResponse.body : {};
  }

  /**
   * è·å¾æ¥å£è¿åçååºç 
   */
  public getCode(): number {
    return this.getResponseBody().code || 0;
  }

  /**
   * è·å¾æ¥å£è¿åçéå ä¿¡æ¯
   */
  public getMessage(): string {
    return this.getResponseBody().message || '';
  }

  /**
   * è·å¾æ¥å£è¿åçåä¿¡æ¯
   */
  public getMetas(): { [name: string]: any } {
    if (!this.meta) {
      this.meta = this.getResponseBody().meta || {};
    }
    return this.meta;
  }

  /**
   * è·å¾æ¥å£è¿åçæå®åä¿¡æ¯
   * @param name åä¿¡æ¯é®å
   * @param defaultValue é»è®¤å¼
   */
  public getMeta(name: string, defaultValue?: any): any {
    const metas = this.getMetas();
    return metas[name] || defaultValue || null;
  }

  /**
   * æå¨è®¾ç½®åä¿¡æ¯
   * @param name åä¿¡æ¯é®å
   * @param value åä¿¡æ¯å¼
   */
  public setMeta(name: string, value: any): NgxExcelHttpResponse {
    this.getMeta(name);
    this.meta[name] = value;
    return this;
  }

  /**
   * è·å¾æ¥å£è¿åçä¸»èµæº
   * @param transform è½¬æ¢æ¹æ³
   */
  public getModel<T>(transform?: (o: any) => T): T {
    if (!this.model) {
      this.model = typeof (this.getResponseBody().data) === 'undefined' ? null : (
        transform ? transform(this.getResponseBody().data) : (this.getResponseBody().data as T)
      );
    }
    return this.model as T;
  }

  /**
   * æå¨è®¾ç½®ä¸»èµæº
   * @param model ä¸»èµæº
   */
  public setModel<T>(model: T): NgxExcelHttpResponse {
    this.model = model;
    return this;
  }

  /**
   * è·å¾æ¥å£è¿åçèµæºéå
   * @param name èµæºéåé®å
   * @param transform è½¬æ¢æ¹æ³
   */
  public getCollection<T>(name: string, transform?: (o: any) => T): T[] {
    if (!this.collections[name]) {
      const collection = (
        typeof (this.getResponseBody()._embedded) === 'undefined' ||
        typeof (this.getResponseBody()._embedded[name]) === 'undefined'
      ) ? [] : (
          transform ?
            Array.from(this.getResponseBody()._embedded[name]).map(transform) :
            (this.getResponseBody()._embedded[name] as T[])
        );
      this.collections[name] = collection;
    }
    return this.collections[name] as T[];
  }

  /**
   * æå¨è®¾ç½®èµæºéå
   * @param name èµæºéåé®å
   * @param collection éååè¡¨
   */
  public setCollection<T>(name: string, collection: T[]): NgxExcelHttpResponse {
    this.collections[name] = collection;
    return this;
  }

}
